import intl from "react-intl-universal";
import { TbAdjustmentsHorizontal, TbCalendar, TbSwitchHorizontal } from "react-icons/tb";
import { ModernFilterBar } from "../../../../../Components/Molecules/Filters/ModernFilterBar";
import {
  CheckboxListFilterPanel,
  DateFilterPanel,
} from "../../../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_BAAS_API_LOGS_FILTERS,
  buildBaasApiLogsFilterTags,
  getBaasApiLogMethodOptions,
  getBaasApiLogStatusOptions,
  hasActiveBaasApiLogsFilters,
  isBaasApiLogsChipFilterActive,
  removeBaasApiLogsFilterTag,
} from "../baasApiLogsFilters";

const HidePrefCheckbox = ({ id, label, checked, onChange }) => (
  <label
    htmlFor={id}
    className="inline-flex cursor-pointer items-center gap-2 text-sm text-gray-600 dark:text-gray-300"
  >
    <input
      id={id}
      type="checkbox"
      className="h-4 w-4 rounded border-gray-300 text-brand-primary focus:ring-brand-primary dark:border-gray-600 dark:bg-brand-dark-elevated"
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
    />
    <span>{label}</span>
  </label>
);

export const BaasApiLogsFilterBar = ({
  filters,
  onFiltersChange,
  hidePrefs,
  onHidePrefsChange,
  filteredItems,
}) => {
  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("baas.api.logs.filterDate"),
      active: isBaasApiLogsChipFilterActive(filters, "date"),
    },
    {
      id: "status",
      icon: TbAdjustmentsHorizontal,
      label: intl.get("baas.api.logs.filterStatus"),
      active: isBaasApiLogsChipFilterActive(filters, "status"),
    },
    {
      id: "method",
      icon: TbSwitchHorizontal,
      label: intl.get("baas.api.logs.filterMethod"),
      active: isBaasApiLogsChipFilterActive(filters, "method"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "status":
        return (
          <CheckboxListFilterPanel
            options={getBaasApiLogStatusOptions()}
            selectedValues={draft.statusClasses || []}
            onChange={(statusClasses) => onChange({ ...draft, statusClasses })}
            idPrefix="baas-api-logs-status"
          />
        );
      case "method":
        return (
          <CheckboxListFilterPanel
            options={getBaasApiLogMethodOptions()}
            selectedValues={draft.methods || []}
            onChange={(methods) => onChange({ ...draft, methods })}
            idPrefix="baas-api-logs-method"
          />
        );
      default:
        return null;
    }
  };

  const hidePrefsActions = (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
      <HidePrefCheckbox
        id="baas-api-logs-hide-carteira"
        label={intl.get("baas.api.logs.hideCarteira")}
        checked={Boolean(hidePrefs?.hideCarteira)}
        onChange={(hideCarteira) =>
          onHidePrefsChange({ ...hidePrefs, hideCarteira })
        }
      />
      <HidePrefCheckbox
        id="baas-api-logs-hide-private"
        label={intl.get("baas.api.logs.hidePrivateRoutes")}
        checked={Boolean(hidePrefs?.hidePrivateRoutes)}
        onChange={(hidePrivateRoutes) =>
          onHidePrefsChange({ ...hidePrefs, hidePrivateRoutes })
        }
      />
    </div>
  );

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_BAAS_API_LOGS_FILTERS}
      searchPlaceholder={intl.get("baas.api.logs.searchPlaceholder")}
      filterButtons={filterButtons}
      buildFilterTags={buildBaasApiLogsFilterTags}
      hasActiveFilters={hasActiveBaasApiLogsFilters}
      removeFilterTag={removeBaasApiLogsFilterTag}
      renderPanelContent={renderPanelContent}
      filteredItems={filteredItems}
      leadingActions={hidePrefsActions}
      panelTitles={{
        date: intl.get("baas.api.logs.filterDate"),
        status: intl.get("baas.api.logs.filterStatus"),
        method: intl.get("baas.api.logs.filterMethod"),
      }}
    />
  );
};
